import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

declare var paypal: any;

@Injectable({
  providedIn: 'root'
})
export class PaypalService {

  private loadPromise: Promise<void> | null = null;

  load(): Promise<void> {
    if (typeof paypal !== 'undefined') {
      return Promise.resolve();
    }
    if (!this.loadPromise) {
      this.loadPromise = new Promise<void>((resolve, reject) => {
        const script = document.createElement('script');
        script.src = `https://www.paypal.com/sdk/js?client-id=${environment.paypalClientId}&currency=GBP&enable-funding=card`;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('Failed to load PayPal SDK'));
        document.head.appendChild(script);
      });
    }
    return this.loadPromise;
  }
}
